import { HttpErrorResponse } from '@angular/common/http';

const productStateMessages: Record<string, string> = {
    anthology_section_collection_forbidden: 'Esta sección se gestiona dentro de su antología.',
    anthology_not_in_collection: 'Esta antología ya no está en tu biblioteca.',
    anthology_section_relation_not_found: 'Esta sección ya no pertenece a la antología.',
    invalid_token: 'Tu sesión ya no es válida. Inicia sesión de nuevo.',
    user_not_found: 'Tu sesión ya no está disponible. Inicia sesión de nuevo.',
    session_refresh_invalid: 'La sesión ha caducado. Inicia sesión de nuevo.',
    session_revoked: 'Esta sesión se ha cerrado desde la seguridad de la cuenta.',
    refresh_replay_detected: 'La sesión de este dispositivo se cerró por seguridad.',
    firebase_identity_revoked: 'Tu identidad de acceso ya no está disponible. Inicia sesión de nuevo.',
    access_method_not_enabled: 'Este método de acceso no está habilitado.',
    access_method_already_linked: 'Ese método ya está vinculado a la cuenta.',
    access_method_conflict: 'Ese método pertenece a otra cuenta y no puede vincularse automáticamente.',
    link_ticket_invalid: 'La vinculación ha caducado. Inicia el proceso de nuevo.',
    last_recoverable_access_method: 'No puedes retirar el último método con el que puedes recuperar la cuenta.',
    phone_not_linked: 'Ese teléfono no está vinculado a ninguna cuenta.',
    phone_preflight_required: 'Valida primero el teléfono antes de solicitar el código.',
    interface_preferences_conflict: 'El tema cambió en otro dispositivo.',
    notification_preferences_internal_error: 'No se han podido guardar las preferencias de notificaciones. Inténtalo de nuevo más tarde.',
    account_sanctioned: 'Las funciones sociales de esta cuenta están restringidas temporalmente.',
    capability_sanctioned: 'Esta acción no está disponible por una restricción de cuenta.',
    usage_policy_acceptance_required: 'Debes aceptar la política de uso antes de continuar.',
    creation_policy_acceptance_required: 'Debes aceptar la política de creación antes de publicar o modificar contenido.',
    club_owner_limit_reached: 'Ya administras un club propio. Solo puedes crear uno.',
    club_membership_limit_reached: 'Ya participas en tres clubes activos. Sal de uno antes de unirte a otro.',
    club_post_target_unavailable: 'No puedes publicar en ese club o ya no está disponible.',
    invalid_comment_spoiler: 'El contexto de spoiler del comentario no es válido.',
    invalid_comment_spoiler_range: 'El rango de páginas del spoiler no es válido.',
    invalid_comment_spoiler_chapter: 'El capítulo indicado no pertenece al libro del spoiler.',
    comment_spoiler_incompatible_with_post: 'El spoiler del comentario debe respetar el contexto de la publicación.',
    club_access_unavailable: 'Este club ya no está disponible para tu cuenta.',
    club_moderator_required: 'Esta acción requiere permisos de moderación del club.',
    club_owner_required: 'Esta acción requiere ser propietario del club.',
    club_poll_closed: 'La encuesta ya está cerrada y se muestra en solo lectura.',
    club_poll_vote_conflict: 'Tu voto cambió en otro momento. Revisa la encuesta antes de volver a votarla.',
    club_reading_not_found: 'La lectura seleccionada ya no existe. Se ha actualizado el club.',
    club_milestone_not_found: 'El hito ya no existe. Se ha actualizado el club.',
    club_event_not_found: 'El evento ya no existe. Se ha actualizado el club.',
    club_member_not_found: 'El miembro ya no pertenece al club. Se ha actualizado el listado.',
    club_owner_cannot_leave: 'La persona propietaria no puede abandonar el club; debe transferirlo o eliminarlo.',
    community_report_group_already_resolved: 'La denuncia ya había sido resuelta. Se ha actualizado la bandeja.',
    appeal_already_resolved: 'La alegación ya había sido resuelta. Se ha actualizado la cola.',
    appeal_not_available: 'La alegación ya no está disponible.',
    policy_draft_required: 'No hay un borrador publicable. Se ha recargado la política.',
    moderation_case_not_found: 'El caso ya no existe. Se ha actualizado el listado.',
    system_case_immutable: 'Este caso del sistema es de solo lectura para ese campo.',
    system_case_cannot_be_deleted: 'Los casos del sistema no pueden eliminarse.',
    moderation_case_disabled: 'El caso está deshabilitado. Se ha actualizado el listado.',
    moderation_case_has_no_stages: 'El caso no tiene etapas configuradas. Corrígelo antes de registrar el incidente.',
    moderation_stage_not_found: 'La configuración de etapas cambió. Revisa el caso antes de reintentar.',
    deleted_account_cannot_be_sanctioned: 'La cuenta fue eliminada y no puede sancionarse.',
    legacy_banned_account: 'La cuenta tiene un baneo heredado y se mantiene en solo lectura.',
    invalid_admin_users_query: 'Los filtros o el cursor de usuarios no son válidos. Revisa la búsqueda.',
    invalid_admin_user_detail_query: 'El cursor del expediente no es válido. Vuelve a abrir la ficha.',
    invalid_admin_audit_query: 'Los filtros o el cursor de auditoría no son válidos.',
    admin_user_not_found: 'La cuenta ya no existe. Se actualizará el listado.',
    admin_role_self_change_forbidden: 'No puedes modificar tu propio rol.',
    last_active_admin_required: 'Debe permanecer otra cuenta administradora activa.',
    admin_role_required: 'Selecciona un rol válido.',
    admin_role_reason_required: 'Explica el motivo del cambio de rol.',
    admin_role_not_found: 'El rol seleccionado ya no está disponible.',
    admin_backup_unavailable_in_qa: 'La descarga de backups no está disponible en el entorno de pruebas.',
    admin_backup_generation_failed: 'No se pudo generar el backup. Inténtalo de nuevo más tarde.',
    chat_membership_required: 'Ya no tienes acceso a esta conversación.',
    chat_group_not_found: 'El grupo ya no existe o no está disponible.',
    chat_group_admin_required: 'Esta acción requiere administrar el grupo.',
    chat_group_title_invalid: 'El nombre del grupo debe tener entre 2 y 150 caracteres.',
    chat_group_participants_required: 'Selecciona al menos una amistad para crear el grupo.',
    chat_group_participants_invalid: 'La selección de participantes no es válida.',
    chat_group_participants_limit: 'El grupo admite un máximo de 50 participantes activos.',
    chat_group_participant_not_eligible: 'Esa persona ya no está disponible para este grupo. Se actualizarán los candidatos.',
    chat_group_member_not_found: 'La persona ya no pertenece al grupo.',
    chat_group_last_admin: 'Antes debes convertir a otra persona en administradora del grupo.',
    chat_preferences_version_required: 'No se pueden guardar estas preferencias sin su versión actual.',
    chat_preferences_conflict: 'Tus preferencias de chat cambiaron en otro dispositivo. Se actualizarán antes de guardar.',
    chat_preferences_invalid: 'Las preferencias de chat flotante no son válidas.',
    chat_preferences_geometry_invalid: 'La posición o el tamaño de la ventana no son válidos.',
    chat_float_windows_limit: 'Puedes conservar un máximo de cinco conversaciones flotantes.'
};

const firebaseAuthMessages: Record<string, string> = {
    'auth/network-request-failed': 'No se ha podido completar el acceso. Comprueba tu conexión o prueba otra red.',
    'auth/too-many-requests': 'Se han hecho demasiados intentos desde esta conexión. Espera unos minutos o prueba otra red.',
    'auth/internal-error': 'No se ha podido completar el acceso. Inténtalo de nuevo en unos minutos.',
    'auth/user-disabled': 'Esta identidad de acceso está deshabilitada.',
    'auth/invalid-credential': 'Las credenciales no son válidas o han caducado.',
    'auth/email-already-in-use': 'Ya existe una identidad con ese correo.',
    'auth/invalid-phone-number': 'El número de teléfono no es válido.',
    'auth/quota-exceeded': 'Ahora mismo no se pueden enviar más códigos de verificación. Inténtalo más tarde.'
};

export function getApiErrorCode(error: unknown): string | null {
    if (!error)
        return null;

    if (error instanceof HttpErrorResponse)
        return getApiErrorCode(error.error);

    if (typeof error === 'object') {
        const apiError = error as Record<string, unknown>;
        const raw = apiError['raw'];

        if (raw && raw !== error) {
            const rawCode = getApiErrorCode(raw);
            if (rawCode)
                return rawCode;
        }
        const code = apiError['code'];

        if (typeof code === 'string' && code.trim())
            return code;
    }

    return null;
}

export const connectionErrorMessage = 'No se ha podido conectar con el servidor. Comprueba tu conexión e inténtalo de nuevo.';

/**
 * Texto para el usuario de una respuesta de la API (docs/backend/api/ERRORES.md):
 * el backend garantiza que `error` es una frase final en español. `debug`,
 * `code`, `field` y `details` nunca se muestran.
 */
export function getBackendErrorText(error: unknown): string | null {
    if (error instanceof HttpErrorResponse)
        return getBackendErrorText(error.error);
    if (!error || typeof error !== 'object')
        return null;
    const body = error as Record<string, unknown>;
    const text = body['error'];
    if (typeof text === 'string' && text.trim())
        return text;
    const raw = body['raw'];
    return raw && raw !== error ? getBackendErrorText(raw) : null;
}

export function getApiErrorMessage(error: unknown, fallback: string = 'Error desconocido'): string {
    if (!error)
        return fallback;

    const backendText = getBackendErrorText(error);
    if (backendText)
        return backendText;

    // El `message` de HttpErrorResponse es técnico («Http failure response for…»):
    // sin cuerpo válido se usa el texto de la pantalla o un aviso de conexión.
    if (error instanceof HttpErrorResponse)
        return error.status === 0 ? connectionErrorMessage : fallback;

    // Errores de Firebase: texto propio o el de la pantalla, nunca el código ni su mensaje en inglés.
    const code = getApiErrorCode(error);
    if (code?.startsWith('auth/'))
        return firebaseAuthMessages[code] ?? fallback;

    if (typeof error === 'string')
        return error || fallback;

    // Errores propios de la app: sus textos ya están escritos para el usuario.
    if (error instanceof Error)
        return error.message || fallback;

    if (Array.isArray(error))
        return error.map(item => getApiErrorMessage(item, '')).filter(Boolean).join('\n') || fallback;

    if (typeof error === 'object') {
        const apiError = error as Record<string, unknown>;
        const nested = apiError['error'];
        if (nested && typeof nested === 'object')
            return getApiErrorMessage(nested, fallback);

        for (const key of ['message', 'detail', 'title']) {
            const value = apiError[key];
            if (typeof value === 'string' && value.trim())
                return value;
        }

        const messages = apiError['messages'];
        if (Array.isArray(messages)) {
            const message = messages.map(item => getApiErrorMessage(item, '')).filter(Boolean).join('\n');
            if (message)
                return message;
        }
    }

    return fallback;
}

/**
 * Igual que getApiErrorMessage, pero con textos propios para los códigos de estado
 * de producto cuando el error no trae ya su frase del backend (p. ej. tiempo real).
 */
export function getProductStateMessage(error: unknown, fallback: string = 'Esta acción no está disponible actualmente.'): string {
    const backendText = getBackendErrorText(error);
    if (backendText)
        return backendText;
    const code = getApiErrorCode(error);
    return (code && productStateMessages[code]) || getApiErrorMessage(error, fallback);
}
